/* eslint-disable react/prop-types */
import React from 'react';

const HRDeclarationForm = ({ data }) => {
  if (!data) {
    return null;
  }

  const { personal_information, financial_details, professional_details } =
    data;
  return (
    <React.Fragment>
      <style>
        {`
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }

      body {
        font-family: "Times New Roman", serif;
        // background-color: #f0f0f0;
        // padding: 20px;
        font-size: 12px;
      }

      .print-btn {
        position: fixed;
        top: 10px;
        right: 10px;
        background: #4caf50;
        color: white;
        border: none;
        padding: 10px 20px;
        border-radius: 5px;
        cursor: pointer;
        font-size: 14px;
        font-weight: bold;
        z-index: 1000;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
      }

      .print-btn:hover {
        background: #45a049;
      }

      .container-hr {
        max-width: 210mm;
        min-height: 297mm;
        margin: 0 auto;
        background: white;
        padding: 25mm;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
        position: relative;
      }

      .form-number {
        text-align: right;
        font-size: 11px;
        margin-bottom: 25px;
        font-weight: normal;
      }

      .title {
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        text-decoration: underline;
        margin-bottom: 35px;
        letter-spacing: 1px;
      }

      .content {
        font-size: 12px;
        line-height: 1.8;
      }

      .line {
        margin-bottom: 5px;
        position: relative;
        display: flex;
      }

      .line-start {
        display: block;
        flex-shrink: 0;
      }

      .fill-line {
        display: block;

        /* border-bottom: 1px solid #000; */
        min-width: 200px;
        width: 100%;
        text-align: center;
        margin: 0 3px;
        padding: 0 5px 2px 5px;
        position: relative;
        /* top: -1px; */
      }

      .fill-line::before{
        content: '';
        position: absolute;
        /* top: -1px; */
        left: 0;
        right: 0;
        bottom: 5px;
        border-bottom: 0.5px solid #000;
        


      }

      .fill-line.name {
        min-width: 480px;
        font-weight: bold;
      }

      .fill-line.father {
        min-width: 520px;
        font-weight: bold;
      }

      .fill-line.address {
        min-width: 450px;
        font-weight: bold;
      }

      .fill-line.district {
        min-width: 200px;
        font-weight: bold;
      }

      .fill-line.state {
        min-width: 250px;
        font-weight: bold;
      }

      .fill-line.pin {
        min-width: 80px;
        font-weight: bold;
      }

      .fill-line.contact {
        min-width: 150px;
      }

      .fill-line.caste {
        min-width: 100px;
        font-weight: bold;
      }

      .fill-line.position {
        min-width: 300px;
        font-weight: bold;
      }

      .company-line {
        margin: 15px 0;
        margin-top: 5px;
      }

      .company-name {
        font-weight: bold;
      }

      .paragraph {
        margin: 20px 0;
        text-align: justify;
        line-height: 1.6;
      }

      .bank-section {
        margin: 30px 0 80px 0;
        max-width: 50%;
      }

      .bank-line {
        margin-bottom: 10px;
        position: relative;
        display: flex;
      }

      .fill-line.bank {
        min-width: 200px;
        font-weight: bold;
      }

      .fill-line.account {
        min-width: 200px;
        font-weight: bold;
      }

      .fill-line.place {
        min-width: 200px;
        font-weight: bold;
      }

      .fill-line.date {
        min-width: 200px;
      }

      .signature-area {
        position: absolute;
        bottom: 50px;
        left: 25mm;
        right: 25mm;
        display: flex;
        justify-content: space-between;
      }

      .signature-box {
        width: 200px;
        text-align: center;
      }

      .signature-space {
        height: 60px;
        border-bottom: 1px solid #000;
        margin-bottom: 8px;
      }

      .signature-text {
        font-size: 11px;
        line-height: 1.3;
      }

      @media print {
        body {
          background: white;
          padding: 0;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        .print-btn {
          display: none !important;
        }

        .container-hr {
          box-shadow: none;
          margin: 0;
          padding: 15mm;
          max-width: none;
          width: 100%;
          min-height: auto;
        }

        .signature-area {
          position: relative;
          bottom: auto;
          left: auto;
          right: auto;
          margin-top: 60px;
        }

        @page {
          size: A4;
          margin: 10mm;
        }
      }

      @media screen {
        .container-hr {
          margin-bottom: 50px;
        }
      }
    `}
      </style>
      <div className="container-hr">
        <div className="title">DECLARATION</div>
        <div className="content">
          <div className="line">
            <span className="line-start">I, </span>
            <span className="fill-line name">
              {personal_information.first_name} {personal_information.last_name}{' '}
              (EMPLOYEE CODE: {personal_information.employee_unique_id})
            </span>
            <span>,</span>
          </div>
          <div className="line">
            <span className="line-start">S/O </span>
            <span className="fill-line father">
              {personal_information.father_name}
            </span>
            <div>,</div>
          </div>
          <div className="line">
            <span className="line-start">Permanent Address </span>
            <span className="fill-line address">
              {personal_information.permanent_address}
            </span>
            <div> ,</div>
          </div>
          <div className="line">
            <span className="line-start">Dist. </span>
            <span className="fill-line district"></span>
            <div style={{ flexShrink: 0 }}>, State </div>
            <span className="fill-line state"></span>
            <div> ,</div>
          </div>
          <div className="line" style={{ marginBottom: 20 }}>
            <span className="line-start">PIN </span>
            <span className="fill-line pin"></span>
            <div style={{ flexShrink: 0 }}>, Contact No </div>
            <span className="fill-line contact">
              {personal_information.employee_mobile}
            </span>
            <div style={{ flexShrink: 0 }}>, Caste </div>
            <span className="fill-line caste"></span>
            <span> ,</span>
          </div>
          <div className="line">
            <span className="line-start">
              is hereby state and declare that, I am working as a
            </span>
            <span className="fill-line position">
              {professional_details.designation_name}
            </span>
          </div>
          <div className="company-line">
            with
            <span className="company-name">KALYANI VENTURES LIMITED</span> under
            <span className="company-name">
              VEDANTA JHARSUGUDA (PLANT-1), JHARSUGUDA, ODISHA (ORISSA)
            </span>
            .
          </div>
          <div className="paragraph">
            I am getting my Wages/Salary by Cheque/Bank of every month and I
            have no objection on the mode of my wage payment.
          </div>
          <div className="bank-section">
            <div className="bank-line">
              <span className="line-start">Bank Name </span>
              <span className="fill-line bank">
                {financial_details.employee_bank_name}
              </span>
            </div>
            <div className="bank-line">
              <span className="line-start">Account No. </span>
              <span className="fill-line account">
                {financial_details.employee_account_number}
              </span>
            </div>
            <div className="bank-line">
              <span className="line-start">Place </span>
              <span className="fill-line place"></span>
            </div>
            <div className="bank-line">
              <span className="line-start">Date </span>
              <span className="fill-line date" />
            </div>
          </div>
        </div>
        <div className="signature-area">
          <div className="signature-box">
            <div className="signature-space" />
            <div className="signature-text">
              Seal and Signature of Employer
              <br />
              Kalyani Ventures Limited
            </div>
          </div>
          <div className="signature-box">
            <div className="signature-space" />
            <div className="signature-text">
              Signature or thumb impression of Employee
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default HRDeclarationForm;
